var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 8,
    viewBox: "0 0 26 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M25.3561 4.60355C25.5513 4.40829 25.5513 4.09171 25.3561 3.89645L22.1741 0.714466C21.9788 0.519204 21.6623 0.519204 21.467 0.714466C21.2717 0.909728 21.2717 1.22631 21.467 1.42157L24.2954 4.25L21.467 7.07843C21.2717 7.27369 21.2717 7.59027 21.467 7.78553C21.6623 7.9808 21.9788 7.9808 22.1741 7.78553L25.3561 4.60355ZM0.98999 4.75H25.0025V3.75H0.98999V4.75Z",
    fill: "#3E4DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow2.947bbfb679cf3baea711a6021d2df0e5.svg";
export { ForwardRef as ReactComponent };